import SETTINGS_V2_ACTIONS from './SettingsV2.action';

// Initial state
const initialState = {
    enableEmailCommunication: false,
    enablePhoneCommunication: false,
    passwordExist: 0,
    loading: false,
    deleteAccount: {
        loading: false,
        password: '',
        deleteStatus: '',
        progress: 0,
        isError: false,
        isDeleteAccountModalOpen: false
    },
    ssoAuth: 0,
    oerror_code: null,
    excludedCountries: [],
    emailSection: {
        email: '',
        currentEmail: '',
        password: '',
        isEditing: false,
        isValidEmail: true,
        isLoading: false,
    },
    phoneSection: {
        phone: '',
        phoneCountryCode: '',
        currentPhone: '',
        password: '',
        isEditing: false,
        isLoading: false,
    },
    passwordSection: {
        currentPassword: null,
        newPassword: null,
        confirmPassword: null,
        isEditing: false,
        isLoading: false,
    },
};

// Helper function to deep merge objects
const deepMerge = (target, source) => {
    const result = { ...target };
    for (const key in source) {
        if (
            source.hasOwnProperty(key) &&
            typeof source[key] === 'object' &&
            !Array.isArray(source[key]) &&
            source[key] !== null &&
            typeof result[key] === 'object'
        ) {
            result[key] = deepMerge(result[key], source[key]);
        } else {
            result[key] = source[key];
        }
    }
    return result;
};

const settingsV2Reducer = (state = initialState, action) => {
    switch (action.type) {
        case SETTINGS_V2_ACTIONS.UPDATE_STATE_DATA:
            return deepMerge(state, action.payload);
        case SETTINGS_V2_ACTIONS.RESET_STATE_DATA:
            return initialState;
        default:
            return state;
    }
};

export default settingsV2Reducer;
